import 'whatwg-fetch'; // IE10 Polyfill
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'; //IE Polyfill
import 'url-search-params-polyfill'; // Edge Polyfill



export default function(url, options = {}) {
    console.log('custom fetch', url);
    let controller = new AbortController();
    let signal = controller.signal;

    let headers = undefined;
    if(options.method === 'POST' || options.body){
        headers = {
            'X-Requested-With' : 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            ...options.headers
        }
    }else{
        headers = {
            'X-Requested-With' : 'XMLHttpRequest',
            ...options.headers
        }
    }


    if(options.method && options.method.toUpperCase() === 'GET' && options.body) {
        url = addSearchParamsToUrl(url, new URLSearchParams(options.body));
        let {body, ...newOptions} = options
        options = newOptions;
    }

    /**
        Special fix for URLSearchParams in older browser. Old browsers dont automatically use toString() in the body.
     */
    if(options.body && options.body instanceof URLSearchParams){
        options = {...options, body: options.body.toString()}
    }

    let pendingRequest = fetch(url, {
        method: typeof options.body !== 'undefined' ? 'POST' : 'GET',
        signal: signal,
        credentials: 'same-origin', /** this is needed so cookies get sent with the fetch api automatically on the same-origin policy in old browsers **/
        ...options,
        headers
    });

    pendingRequest.abort = function () {
        controller.abort();
        pendingRequest = null;
    };
    pendingRequest.controller = controller;
    pendingRequest.signal = signal;

    return pendingRequest;
}

export function addSearchParamsToUrl(url, searchParams) {
    url = new URL(url, location.origin);

    let searchParamsArray = Array.from(searchParams);
    searchParamsArray.forEach(([name]) => url.searchParams.delete(name));
    searchParamsArray.forEach(([name, value]) => url.searchParams.append(name, value));

    return url;
}